
export const ChooseProductCondition = [
    {
        Type: 1,
        Name: "SKU"
    },
    {
        Type: 2,
        Name: "Product Group"
    },
    {
        Type: 3,
        Name: "All Products"
    }
];